<template>
  <div>
    <div
      class="controls-container bg-white bg-opacity-50 rounded-full flex items-center justify-between"
      :class="{ 'py-1': paddingSize === 'sm', 'py-2': paddingSize === 'md' }"
    >
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps({
  paddingSize: {
    type: String,
    default: 'md',
  },
})
</script>

<style lang="stylus" scoped>
.controls-container
  &:empty
    @apply hidden

  &.py-1
    margin-left: -0.25rem
    margin-right: -0.25rem

    :deep(> *) {
      margin-left: 0.25rem
      margin-right: 0.25rem
    }

  &.py-2
    margin-left: -0.5rem
    margin-right: -0.5rem

    :deep(> *) {
      margin-left: 0.5rem
      margin-right: 0.5rem
    }
</style>
